module.exports = __webpack_public_path__ + "media/app/assets/imgs/follow-confirmed-dda5557ce8fd9fdf58dbc290955e5ab3.svg";